<style>
  .DownLoaded{
    background-color:#ff9595 !important;
  }

  .Uploaded{
    background-color:#a595ff  !important;
  }

  .Certificate{
    background-color:#95ff9e  !important;
  }


</style>

<div class="col-md-12 mb-30" *ngIf="Selected_Calibration_Id==-1">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Instrument Reception List</h5>
     <br/>
     <br>

     <div class="row">
      <div class="col-md-4">
        <div class="card card-statistics h-100">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-left icon-box bg-success rounded-circle">
                <span class="text-white">
                  <i class="fa fa-file highlight-icon" aria-hidden="true"></i>
                </span>
              </div>
              <div class="float-right text-right">
                <p class="card-text text-dark">  Count Receipt Number <b>Current Month</b> </p>
                <h4>{{current_Month}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card-statistics h-100">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-left icon-box bg-info rounded-circle">
                <span class="text-white">
                  <i class="fa fa-file highlight-icon" aria-hidden="true"></i>
                </span>
              </div>
              <div class="float-right text-right">
                <p class="card-text text-dark">Count Receipt Number <b>Previous Month</b></p>
                <h4>{{last_Month}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card-statistics h-100">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-left icon-box bg-warning rounded-circle">
                <span class="text-white">
                  <i class="fa fa-file highlight-icon" aria-hidden="true"></i>
                </span>
              </div>
              <div class="float-right text-right">
                <p class="card-text text-dark">Count Receipt Number <b>Current Year</b> </p>
                <h4>{{current_Year}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <br>
      <br>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Time Range</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..."   class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd  placeholder="Type here..."  class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>
       <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Customer Name	</label>
          <input [(ngModel)]="Filter_customer"  name="Filter_customer" type="text" class="form-control"  placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Receipt Number </label>
          <input [(ngModel)]="Filter_code"  name="Filter_customer" type="number" class="form-control"  placeholder="Type here to search...">
        </div>
      </div>

     <br/>
     <div class="row">
      <div  class="form-group col-md-12" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Calibration(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button *ngIf="!Procssing" (click)="exportexcel()" type="button"  class="btn btn-warning" style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <button *ngIf="!Procssing" (click)="OnSet_Selected_Calibration_Id(0)" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add New Record </button>
        <button *ngIf="Procssing" type="button"  class="btn btn-info" style="margin-right: 5px;"> Please wait...  <i class="fa fa-spin fa-spinner"></i> </button>
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Receipt Number</th>
              <th>Letter Number</th>
              <th>Customer Name</th>
              <th>Registration Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Calibration
            | paginate
                    : {
                        id: 'DataList_CalibrationTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Calibration).length
                      }
            " [ngClass]="{'DownLoaded': item.status_lab===1,'Uploaded': item.status_lab===2,'Certificate': item.status_lab===3}">
             <td>{{DataList_Calibration.indexOf(item)+1}}</td>
             <td>{{item.code}}</td>
             <td>{{item.letterRequestCustomer_id}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.persianDate}} </td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <!--
                          <a class="dropdown-item"  (click)="openModal_upload(templateUpload,item)" ><i class="fa fa-eye"></i> Attachment </a>
                          <a class="dropdown-item" [routerLink]="['/CalibrationReceptionForm',{id:item.id}]"><i class="fa fa-edit"></i> Edit </a>
                        -->
                        <a style="cursor: pointer;" class="dropdown-item" (click)="OnSet_Selected_Calibration_Id(item.id)"><i class="fa fa-edit"></i> Edit </a>
                        <a  style="cursor: pointer;" *ngIf="item.status_lab==0" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> Delete </a>

                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_CalibrationTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<app-CalibrationReceptionForm
    *ngIf="Selected_Calibration_Id>-1"
    (OnBack_Calibration_Action)="OnSet_Back_Calibration_Id($event)"
    [Calibration_Form_Id]="Selected_Calibration_Id">

</app-CalibrationReceptionForm>




<table id="excel-table" style="display: none;" >
  <thead >
    <tr>
      <th>#</th>
      <th>Receipt Number</th>
      <th>Customer Name</th>
      <th>Reception Date Equipment</th>
      <th>Certificate Recipient Name</th>
      <th>Certificate Recipient Description</th>
      <th>Delivered By</th>

      <th>Calibration Representative Name</th>

      <th>Primary Mobile 1</th>
      <th>Alternate Mobile 1</th>
      <th>Messaging Mobile 1</th>

      <th>Primary Mobile 2</th>
      <th>Alternate Mobile 2</th>
      <th>Messaging Mobile 2</th>

      <th>Primary Mobile 3</th>
      <th>Alternate Mobile 3</th>
      <th>Messaging Mobile 3</th>

    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Calibration_Excel">
     <td>{{DataList_Calibration_Excel.indexOf(item)+1}}</td>
     <td>{{item['code']}}</td>
     <td>{{item['customerName']}}</td>
     <td>{{item['dateDaryaft']}}</td>
     <td>{{item['customerGirandeh']}}</td>
     <td>{{item['fatorDsc']}}</td>
     <td>{{item['tahvilDahandeh']}}</td>
     <td>{{item['name']}}</td>

     <td>{{item['tamas1']}}</td>
     <td>{{item['jaygozin1']}}</td>
     <td>{{item['majazi1']}}</td>

     <td>{{item['tamas2']}}</td>
     <td>{{item['jaygozin2']}}</td>
     <td>{{item['majazi2']}}</td>

     <td>{{item['tamas3']}}</td>
     <td>{{item['jaygozin3']}}</td>
     <td>{{item['majazi3']}}</td>

    </tr>
  </tbody>
</table>

<ng-template #templateUpload>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> Attachment  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_upload.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> Select File </label>
            <input #file  type="file" class="form-control" >
        </div>
      </div>
  </div>

 </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingUpload" src="assets/Loading.gif" style="width: 25px;" />
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Calibration/{{Selected_DataList_Calibration.filename}}" *ngIf="Selected_DataList_Calibration.filename!=''"  ><i class="fa fa-eye"></i> Attachment </a>
    <button  *ngIf="!ProcssingUpload" type="button" (click)="upload(file.files)"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-upload"></i> Upload File </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_upload.hide()">Close</button>
  </div>
</ng-template>


<ng-template #template>
  <div class="modal-header">
    <h4   class="modal-title pull-left">Delete Receipt '{{Data_Seleted_Delete.code}}' </h4>

     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body" >
    <div class="form-group col-md-12">
      <label for="exampleInputEmail1">Description</label>
      <input [(ngModel)]="RejectDsc" name="RejectDsc" type="text" class="form-control"  placeholder="Type here...">
    </div>
  </div>
  <div class="modal-footer">
    <button   type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> Delete <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
